export const defaultData = {
  contractorDetails: {
    companyName: '',
    engineerName: '',
    telephone: '',
    accreditationNumber: ''
  },
  propertyDetails: {
    clientName: '',
    propertyAddress: '',
    postCode: '',
    flushDate: new Date().toISOString().split('T')[0]
  },
  systemOverview: {
    systemType: 'Sealed System (Combi/System Boiler)',
    boilerMakeModel: '',
    radiatorCount: 10,
    underfloorHeatingLoops: 0,
    pipeworkMaterial: 'Copper',
    reasonForFlush: 'New Boiler Installation (BS 7593 Benchmark)'
  },
  preFlushAssessment: {
    preFlushWaterAppearance: 'Black / Heavy Magnetite Sludge',
    preFlushTdsPpm: 680,
    preFlushPh: 6.4,
    mainsWaterTdsPpm: 210,
    radiatorColdSpotsCount: 4
  },
  flushingProcess: {
    flushingMachineModel: 'Kamco CF90 Quantum / Norstrom Proflush',
    magneticFilterToolFitted: 'Yes',
    chemicalCleanerBrand: 'Fernox Cleaner F3 / Sentinel X400',
    chemicalCleanerDosage: 1.0,
    flowReversalExecuted: 'Yes',
    flushDurationHours: 4.5,
    magneticSludgeRemovedGrams: 450
  },
  postFlushVerification: {
    postFlushWaterAppearance: 'Crystal Clear',
    postFlushTdsPpm: 215,
    tdsComparisonPct: 2.3,
    postFlushPh: 7.6,
    permanentMagneticFilterFitted: 'Yes',
    permanentFilterMakeModel: 'Adey MagnaClean Professional 2',
    chemicalInhibitorBrand: 'Fernox Protector F1 / Sentinel X100',
    chemicalInhibitorDosageLtrs: 1.0,
    inhibitorTestKitVerified: 'Yes - Verified Compliant'
  },
  declarations: {
    engineerComments: 'Central heating circuit powerflushed and protected in accordance with BS 7593:2019 code of practice. All radiators balanced and venting clear.',
    nextInhibitorCheckDue: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    engineerSignature: '',
    customerSignature: ''
  }
};

export default defaultData;
